/* @jsx h */
import { defineComponent, h, Ref } from "vue";
import { useRoute } from "vue-router";
import epsonImageURL from "@app/images/printers/epson-tm30iii.png?url";
import { Device, Printer } from "@lemmonhq/types";
import { useShop, useToast } from "../../providers";
import { watch } from "vue";
import { isPrinterOnline } from "@app/utils/index";
import { useLocalization } from "@lemmonhq/uikit";

export type PrinterDetailsProps = {
  devices: Ref<Device[]>;
};
export const PrinterDetails = defineComponent<PrinterDetailsProps>({
  name: "PrinterDetails",

  props: ["devices"],
  setup(props) {
    const route = useRoute();
    const { t } = useLocalization();
    const toast = useToast();
    return () => {
      console.log("PrinterDetails", route, route.params);
      const id = route.params.id;
      if (!id) return <div />;
      console.log("props", props.devices.value);
      const printer = props.devices.value.find(
        (el) =>
          el.type === "printer" && el.device.id === parseInt(id as string),
      )?.device as Printer;
      if (!printer) return <div />;
      const shop = useShop();

      watch([shop.printerStatuses], async ([printerStatuses]) => {
        // console.log("watch triggered", printerStatuses);
      });
      const printerDPURL = `${import.meta.env.VITE_ENV === "production" ? "https://printers.thelemmon.ch" : import.meta.env.VITE_PUBLIC_URL}/api/v2/print_jobs/${printer.guid}`;
      return (
        <div class="space-y-8 flex-1 p-2 lg:p-0">
          <div class="flex flex-row items-center gap-4 border-b px-0 lg:px-2 py-4 ">
            <div class=" border component rounded p-2 lg:p-4 flex justify-center items-center">
              <div class="flex justify-center items-center w-24 h-24">
                <img
                  src={epsonImageURL}
                  alt="EPSON TM-M30"
                  class="w-full h-full"
                />
              </div>
            </div>
            <div class="pl-0">
              <div class="flex flex-col md:flex-row items-start gap-4 mb-2">
                <h2 class="text-2xl text-accent break-all">
                  {printer?.name} | EPSON TM-M30III
                </h2>
                {isPrinterOnline(
                  shop.printerStatuses.timestamps,
                  printer.id,
                ) ? (
                  <span
                    key="online"
                    class="px-3 py-1 bg-success text-accent text-sm rounded-full"
                  >
                    {t("devices.core.connected")}
                  </span>
                ) : (
                  <span
                    key="offline"
                    class="px-3 py-1 bg-warning text-black text-sm rounded-full"
                  >
                    {t("devices.core.disconnected")}
                  </span>
                )}
              </div>
              <div class="flex flex-col lg:flex-row lg:items-center gap-2">
                <span>
                  <span class="text-accent font-mono">S/N:</span>{" "}
                  {printer?.serial_number}
                </span>
                <span class="hidden lg:flex">•</span>
                <span class="font-mono">http://{printer.ip}</span>
              </div>
            </div>
          </div>
          <div class="md:pl-5 flex flex-col gap-8">
            <div class="flex flex-col lg:flex-row gap-4">
              <button disabled class="btn btn-primary flex items-center gap-2">
                <span class="flex justify-start items-center">
                  <span class="material-symbols-outlined mr-1 text-2xl">
                    print
                  </span>
                  {t("devices.core.print_test_receipt")}
                </span>
              </button>
              <button
                disabled
                class="btn btn-secondary flex items-center gap-2"
              >
                <span class="flex justify-start items-center">
                  <span class="material-symbols-outlined mr-1 text-2xl">
                    settings
                  </span>
                  Configure Printer
                </span>
              </button>
            </div>
            <div class="flex flex-col">
              <div class="flex items-center gap-2 mb-2">
                <span class="text-accent font-semibold">
                  Server Direct Print URL{" "}
                </span>
              </div>
              <span class="break-all font-mono flex gap-2 justify-start items-center">
                {printerDPURL}
                <button
                  class="btn btn-outline btn-sm gap-2"
                  onClick={() => {
                    const url = printerDPURL;
                    navigator.clipboard.writeText(url);
                    toast.showToast("URL copied!", {
                      type: "info",
                      autoHide: 3000,
                    });
                  }}
                >
                  <span class="material-symbols-outlined text-lg">
                    content_copy
                  </span>
                </button>
              </span>
            </div>

            <div class="component rounded-lg p-2 lg:p-6">
              <h3 class="text-xl mb-4">
                {t("devices.core.about_this_printer")}
              </h3>
              <div class="space-y-3">
                <a
                  target="_blank"
                  href="https://epson.com/Support/Point-of-Sale/Thermal-Printers/Epson-TM-m30III-Series/s/SPT_C31CK51001"
                  class=" hover:text-accent flex items-center gap-2"
                >
                  <span class="flex justify-start items-center">
                    <span class="material-symbols-outlined mr-1 text-2xl">
                      open_in_new
                    </span>
                    {t("devices.core.changing_a paper_roll")}
                  </span>
                </a>
                <a
                  target="_blank"
                  href="https://epson.com/Support/Point-of-Sale/Thermal-Printers/Epson-TM-m30III-Series/s/SPT_C31CK51001"
                  class=" hover:text-accent flex items-center gap-2"
                >
                  <span class="flex justify-start items-center">
                    <span class="material-symbols-outlined mr-1 text-2xl">
                      open_in_new
                    </span>
                    {t("devices.core.connecting_cash_drawer")}
                  </span>
                </a>
                <a
                  target="_blank"
                  href="https://epson.com/Support/Point-of-Sale/Thermal-Printers/Epson-TM-m30III-Series/s/SPT_C31CK51001"
                  class=" hover:text-accent flex items-center gap-2"
                >
                  <span class="flex justify-start items-center">
                    <span class="material-symbols-outlined mr-1 text-2xl">
                      open_in_new
                    </span>
                    {t("devices.core.learn_more")}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    };
  },
});
